module.exports = "https://assets.niwcorp.com/_next/static/images/RectangleShape-a29e6cf56b396c6558fd8eb45bb5e8be.svg";